import React, { Suspense } from 'react';
import { type WrappedComponentProps, injectIntl } from 'react-intl-next';

import { messages } from './messages';

import { Flex } from '@atlaskit/primitives';

const Lozenge = React.lazy(() =>
	import(
		/* webpackPrefetch: true */
		/* webpackChunkName: "@atlaskit-internal_@atlassian/lozenge" */ '@atlaskit/lozenge'
	).then((module) => {
		return {
			default: module.default,
		};
	}),
);

interface ConfluenceReactivationExperimentTabProps {
	title: string;
}

const Tab = ({ intl, title }: ConfluenceReactivationExperimentTabProps & WrappedComponentProps) => (
	<Flex alignItems="center" columnGap="space.100" testId="confluence-reactivation-experiment-tab">
		{title}
		<Suspense fallback={null}>
			<Lozenge appearance="new">
				{/* TODO: https://product-fabric.atlassian.net/browse/MDS-811 Add render logic for never_active_user vs inactive_user */}
				{intl.formatMessage(messages.never_active_user)}
			</Lozenge>
		</Suspense>
	</Flex>
);

export const ConfluenceReactivationExperimentTab = injectIntl(Tab);
